import React, { Component } from "react";
import Card from "../../../../components/common/Card.js";
import CardHeader from "../../../../components/common/CardHeader.js";
import CircularProgress from '@mui/material/CircularProgress';
import "../../../../components/admin/css/common.css";
import sweetAlert, {
	sweetConfirmAlert,
	sweetStatusAlert,
	sweetAlertInfo,
} from "../../../../components/common/SweetAlert.js";
import SimpleReactValidator from "simple-react-validator";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import config from "../../../../helper/config.js";
import { customerConstants } from "../../../../helper/constants.js";
import { AssessmentCreditPackPriceService } from "../../../../service/manage/exam_subscription/assessCreditPackagePrice.service.js";
import { AssessmentCreditService } from "../../../../service/manage/exam_subscription/assessCredit.service.js";
import AssessPackageCard from './AssessPackageCard.js';
import no_credit_packs from '../../../../assets/images/no_credit_packs.png';
import PaymentGateSolutions from '../img/Payment Gateway Solutions.jpg';
import './Css/AssessmentCredits.css';

const getCustomerFeatureFlag = () => {
	return config.customerConfigs.featureFlag;
};

const customer = getCustomerFeatureFlag()

export default class AssessmentUserCreditPackages extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showInsertModal: false,
			showModal: false,
			isLoading: false,
			isTableDataLoading: false,
			isStudentListLoading: false,
			isModified: false,
			search_id: "",
			isStudentsLoading: false,
			isSubmitting: false,
			registration_id: "",
			editVisibility: true,
			addVisibility: true,
			breadcrumb2: null,
			nodeTitle: null,
			flg_list_active: null,
			credits: "",
			types: "",
			type_id: "",
			type_name: "",
			type_credits: "",
			discount_rate: "",
			level_prices: "",
			credit_packages: "",
			level_price_id: "",
			level_price_name: "",
			level_name: "",
			level_definition: "",
			level_price_credits: "",
			level_price_value: "",
			level_price_currency_type: "",
			level_price_start_date: "",
			level_price_end_date: "",
			credit_id: "",
			name: "",
			definition: "",
			description: "",
			amount: "",
			userType: "",
			total_credits: "",
			isPayEnabled: false,
			showTransactionModal: false,
			selectedTransaction: null,
			creditsPrivilege: null,
			customer: "EdSider",
			sessionId: "",
			isDropHidden: false,
			studentlist: [],
			selectedStudent: "",
			payment_method: "",
			reference_id: "",
			selectedFile: null,
			studentSearchTerm: "",
			selectedOption: "",
			showStudentParentModal: false,
			grades: "",
			assessment_grade_id: "",
			level_type_loading: false,
			without_discount: "",
			discounted_amount: "",
			form_list_id: "",
			userIDs: "",
			selectedStudentGrade: "",
			creditBuyLimit: 0,
			creditBuyLimitStatus: null,
		};

		this.createValidationsInstance();
	}

	handleTabChange = (event, newValue) => {
		this.setState({ activeTab: newValue });
	};
	createValidationsInstance() {
		this.validator = new SimpleReactValidator();
	}

	handleRowClick = (transaction) => {
		this.setState({
			showTransactionModal: true,
			selectedTransaction: transaction,
		});
	};

	handleModalClose = () => {
		this.setState({
			showTransactionModal: false,
			selectedTransaction: null,
		});
	};

	componentDidMount() {
		const { breadcrumb2 = null, nodeTitle = null, flg_list_active = 1, form_list_id = 46 } =
			this.props.props || {};
		const userType = sessionStorage.getItem("userType");
		this.setState(
			{
				breadcrumb2: breadcrumb2,
				isLoading: true,
				nodeTitle: nodeTitle || "Assessment Subscriptions",
				flg_list_active: flg_list_active || 1,
				userType: userType,
				creditsPrivilege: this.props.creditsPrivilege,
				form_list_id: form_list_id || 46,
				customer: getCustomerFeatureFlag(),
			},
			() => {
				if (userType === "student") {
					this.getAllCreditPackages(sessionStorage.getItem("manage_user_id"));
				} else if (userType === "parent") {
					if (flg_list_active === 1) {
						this.setState({ isDropHidden: true });
					}
					this.fetchallstudent();
				}
			}
		);
		this.getCreditBuyLimit();
	}

	getCreditBuyLimit() {
		AssessmentCreditPackPriceService.getLimitOfBuyCreditPackages()
			.then((response) => {
				this.setState(
					{ creditBuyLimit: response.data.limit_count, creditBuyLimitStatus: response.data.status_id }
				);
			})
			.catch((err) => {
				console.error("Failed to get credit buy limit:", err);
			});
	}


	getAllCreditPackages(user_id) {
		const mid = 100;
		this.setState({ isLoading: true });
		AssessmentCreditPackPriceService.getAllActiveCreditPackagesByID(
			mid,
			user_id
		)
			.then((res) => {
				if (res.success && res.data.credit_packages) {
					this.setState(
						() => ({
							credit_packages: res.data.credit_packages,
						})
					);
				}
			})
			.finally(() => {
				this.setState({
					level_type_loading: false,
					isLoading: false,
				});
			});
	}

	componentWillUnmount() {
		if (this.state.customer !== customerConstants.EXO_CUSTOMER2) {
			// Cleanup: Remove the script when the component is unmounted
			const script = document.querySelector("script[src*='checkout.min.js']");
			if (script) {
				document.head.removeChild(script);
			}
		}
	}


	fetchallstudent = () => {
		const mid = 100;
		const lg_user_id = sessionStorage.getItem("manage_user_id");
		const lg_user_table_id = sessionStorage.getItem("table_log_id");
		const form_list_id = 29;
		const { studentSearchTerm } = this.state;

		this.setState({ isStudentListLoading: true });

		let userType = sessionStorage.getItem("userType");

		let user_id;
		let user_table_id;

		if (userType === "parent") {
			user_id = sessionStorage.getItem("parent_group_id");
			user_table_id = sessionStorage.getItem("parent_group_user_table_id");
		} else {
			user_id = lg_user_id;
			user_table_id = lg_user_table_id;
		}
		AssessmentCreditService.getAllStudentsForParent(
			mid,
			form_list_id,
			user_id,
			user_table_id,
			studentSearchTerm,
			userType
		)
			.then((response) => {
				if (response.success) {
					const students = response.data.students || [];
					const userIDs = students.map(
						(student) => student.user_id
					);
					const recentStudentId = sessionStorage.getItem("assessment_credit_pack_last_student_id");
					const hasRecentStudent = students.some(
						(student) => student.user_id === recentStudentId
					);
					const defaultStudentId = hasRecentStudent
						? recentStudentId
						: (students[0]?.user_id || "");

					this.setState(
						{
							studentlist: students,
							userIDs: userIDs,
							selectedStudent: defaultStudentId,
							isLoading: false,
						},
						() => {
							if (defaultStudentId) {
								this.getAllCreditPackages(defaultStudentId);
							} else {
								this.getAllCreditPackages(userIDs);
							}
						}
					);
				} else {
					sweetStatusAlert(
						"Failed!",
						"Error fetching students. Please refresh the screen!",
						"error"
					);
				}
			})
			.catch(() => {
				sweetStatusAlert(
					"Failed!",
					"Error fetching students. Please refresh the screen!",
					"error"
				);
			})
			.finally(() => {
				this.setState({ isStudentListLoading: false });
			});
	};


	handleStudentSelect(event) {
		this.setState({
			isLoading: true,
		});
		if (!event.target.value) {
			this.setState({
				selectedStudent: "",
				// types: [],
				assessment_grade_id: "",
				type_name: "",
				type_credits: "",
				discount_rate: "",
				amount: "",
				total_credits: "",
				level_price_name: "",
				level_definition: "",
			});
			return;
		}
		let student = this.state.studentlist.find(
			(student) => student.user_id === event.target.value
		);
		const selectedStudent = student.user_id;
		if (selectedStudent) {
			sessionStorage.setItem("assessment_credit_pack_last_student_id", selectedStudent);
			this.setState({
				selectedStudent: selectedStudent
			});
		}
		if (selectedStudent) {
			const mid = 100;
			AssessmentCreditPackPriceService.getAllActiveCreditPackagesByID(
				mid,
				selectedStudent
			)
				.then((res) => {
					if (res.success && res.data.credit_packages) {
						this.setState(
							() => ({
								credit_packages: res.data.credit_packages,
							})
						);
					}
				})
				.finally(() => {
					this.setState({
						isLoading: false,
					});
				});
		}
	}

	render() {
		const {
			isLoading,
			isTableDataLoading,
			credit_packages,
			credits,
			creditsPrivilege,
			isDropHidden,
			studentlist,
			selectedStudent,
			selectedStudentGrade,
			userType,
			grades,
			customer,
			assessment_grade_id,
			creditBuyLimit,
			creditBuyLimitStatus,
		} = this.state;

		this.validator.purgeFields();

		return (
			<>
				{isLoading ? (
					<div className="spinner-container">
						<CircularProgress />
					</div>
				) : (
					<Card>
						{userType === "parent" && (
							<>
								<CardHeader>
									{isDropHidden && !isLoading && !isTableDataLoading && (
										<div className="col-md-12 d-flex justify-content-start align-items-center px-0">
											{/* <div className="dropdown mb-2 px-0 col-md-4"> */}
											<div className="row d-flex align-items-end" style={{ width: '100%' }}>
												<div className="col-md-4 col-sm-12">
													<Form.Group
														as={Col}
														md="12"
														controlId="exampleForm.ControlInput3"
														className="px-0"
													>
														<>
															<Form.Select
																aria-label="Select the student"
																name="student_id"
																value={selectedStudent}
																onChange={(event) =>
																	this.handleStudentSelect(event)
																}
															>
																{studentlist.map((student) => (
																	<option
																		key={student.user_id}
																		value={student.user_id}
																	>
																		{student.data_concat}
																	</option>
																))}
															</Form.Select>
														</>
													</Form.Group>
												</div>
												{/* <div className="col-md-4 col-sm-12 mt-1">
													<Form.Group
														controlId="exampleForm.ControlInput1"
													>
														<Form.Label>Select the grade</Form.Label>
														<Form.Select
															aria-label="Default select example"
															name="assessment_grade_id"
															onChange={this.handleChange}
															value={
																assessment_grade_id
																	? assessment_grade_id
																	: userType === "parent" && selectedStudent
																		? selectedStudentGrade
																			? selectedStudentGrade
																			: ""
																		: userType === "student" && gradeMapAvailable
																			? sessionStorage.getItem("studentGrade")
																			: ""
															}
															disabled={userType === "parent" && !selectedStudent}
														>
															{grades.length === 0 ? (
																<option value="" disabled>Loading...</option>
															) : (
																<>
																	<option value="" disabled>Select</option>
																	{grades.map((grade) => (
																		<option
																			value={grade.grade_id}
																			key={grade.grade_id}
																		>
																			{grade.grade}
																		</option>
																	))}
																</>
															)}
														</Form.Select>
													</Form.Group>
												</div> */}
												<div className="col-md-2 col-sm-12" />
											</div>
										</div>
									)}
								</CardHeader>
								{selectedStudent && (
									<>
										{credit_packages.length > 0 ? (
											<>
												<div className="d-flex justify-content-center align-items-center">
													<div className="row" style={{ width: '88vw' }}>
														{credit_packages.map((pkg, index) => (
															<div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 px-5 py-2" key={index}>
																<AssessPackageCard pkg={pkg} selectedStudent={selectedStudent} studentlist={studentlist} customer={customer} limit_count={creditBuyLimit} status={creditBuyLimitStatus} />
															</div>
														))}
													</div>
												</div>
											</>
										) : (
											<div className="col-md-12 col-sm-12">
												<div style={{ paddingTop: '16px', borderRadius: '24px', boxShadow: '0px 0px 4px 4px #b9b9b9' }}>
													<h4 style={{ display: 'flex', justifyContent: 'center' }}>Seems like there are still no any credit package available for this</h4>
													<p style={{ display: 'flex', justifyContent: 'center' }}><img src={no_credit_packs} style={{ height: '50vh' }} /></p>
												</div>
											</div>
										)}
									</>
								)}
							</>
						)}

						{userType === "student" && (
							<><div className="col-md-4 col-sm-12 mt-1 mb-2">
								{/* <div style={{ marginLeft: '24px', marginRight: '24px', marginTop: '16px' }}>
                                    <Form.Label>Select the grade</Form.Label>
                                    <Form.Select
                                        aria-label="Default select example"
                                        name="assessment_grade_id"
                                        onChange={this.handleChange}
                                        value={
                                            assessment_grade_id
                                                ? assessment_grade_id
                                                : userType === "parent" && selectedStudent
                                                    ? credits.length > 0
                                                        ? credits[0].grade
                                                        : ""
                                                    : userType === "student" && gradeMapAvailable
                                                        ? sessionStorage.getItem("studentGrade")
                                                        : ""
                                        }
                                        disabled={userType === "parent" && !selectedStudent}
                                    >
                                        {grades.length === 0 ? (
                                            <option value="" disabled>Loading...</option>
                                        ) : (
                                            <>
                                                <option value="" disabled>Select</option>
                                                {grades.map((grade) => (
                                                    <option
                                                        value={grade.grade_id}
                                                        key={grade.grade_id}
                                                    >
                                                        {grade.grade}
                                                    </option>
                                                ))}
                                            </>
                                        )}
                                    </Form.Select>
                                </div> */}
							</div>
								<div className="d-flex justify-content-center">
									<div className="cardHeaderAsse">
										{credit_packages.length > 0 ? (
											<div className="row" style={{ width: '88vw' }}>
												{credit_packages.map((pkg, index) => (
													<div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 px-5 py-2" key={index}>
														<AssessPackageCard pkg={pkg} selectedStudent={selectedStudent} studentlist={studentlist} customer={customer} limit_count={creditBuyLimit} status={creditBuyLimitStatus} />
													</div>
												))}
											</div>
										) : (
											<div className="col-md-12 col-sm-12">
												<div style={{ paddingTop: '16px', borderRadius: '24px', boxShadow: '0px 0px 4px 4px #b9b9b9' }}>
													<h4 style={{ display: 'flex', justifyContent: 'center' }}>Seems like there are still no any credit package available for this</h4>
													<p style={{ display: 'flex', justifyContent: 'center' }}><img src={no_credit_packs} style={{ height: '50vh' }} /></p>
												</div>
											</div>
										)}
										<div className="w-100 d-flex justify-content-end">
											<img src={PaymentGateSolutions} className="paymentgateimg" />
										</div>
									</div>
								</div>
							</>
						)}
					</Card>
				)}
			</>
		)
	}
}
